/**
 * Per-shop identity colors for avatars and badges. Innu shop ids are UUIDs,
 * so a shop's hue is derived from a stable hash of its id rather than a fixed
 * table — the same shop always gets the same color across sessions.
 */
export interface ShopMeta {
  letter: string;
  gradient: string;
  /** Solid pill classes in the same hue family as the gradient. */
  pill: string;
}

const PALETTE: ReadonlyArray<Omit<ShopMeta, 'letter'>> = [
  { gradient: 'from-emerald-400 to-teal-600', pill: 'bg-emerald-100 text-emerald-700' },
  { gradient: 'from-amber-400 to-orange-600', pill: 'bg-amber-100 text-amber-700' },
  { gradient: 'from-sky-400 to-blue-600', pill: 'bg-sky-100 text-sky-700' },
  { gradient: 'from-rose-400 to-pink-600', pill: 'bg-rose-100 text-rose-700' },
  { gradient: 'from-violet-400 to-purple-600', pill: 'bg-violet-100 text-violet-700' },
  { gradient: 'from-cyan-400 to-sky-600', pill: 'bg-cyan-100 text-cyan-700' },
  { gradient: 'from-lime-400 to-green-600', pill: 'bg-lime-100 text-lime-700' },
  { gradient: 'from-fuchsia-400 to-violet-600', pill: 'bg-fuchsia-100 text-fuchsia-700' },
];

export const ALL_SHOPS_META: ShopMeta = {
  letter: '∗',
  gradient: 'from-zinc-500 to-zinc-800',
  pill: 'bg-zinc-100 text-zinc-700',
};

function hashId(id: string): number {
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
  return h;
}

export function shopMetaFor(id: string, name: string): ShopMeta {
  const base = PALETTE[hashId(id) % PALETTE.length] ?? PALETTE[0]!;
  return { letter: name.trim()[0]?.toUpperCase() ?? '?', ...base };
}
